var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1897 5.51714L10.2225 4.94058L8.44908 1.34527C8.40064 1.24683 8.32095 1.16714 8.22251 1.11871C7.97564 0.996832 7.67564 1.09839 7.5522 1.34527L5.77876 4.94058L1.81158 5.51714C1.7022 5.53277 1.6022 5.58433 1.52564 5.66246C1.43308 5.75759 1.38208 5.88558 1.38383 6.0183C1.38559 6.15103 1.43997 6.27762 1.53501 6.37027L4.40533 9.16871L3.7272 13.1203C3.7113 13.2122 3.72147 13.3067 3.75656 13.3932C3.79166 13.4796 3.85027 13.5545 3.92575 13.6093C4.00123 13.6641 4.09056 13.6967 4.18361 13.7033C4.27666 13.71 4.36971 13.6904 4.4522 13.6468L8.00064 11.7812L11.5491 13.6468C11.646 13.6984 11.7585 13.7156 11.8663 13.6968C12.1381 13.65 12.321 13.3921 12.2741 13.1203L11.596 9.16871L14.4663 6.37027C14.5444 6.29371 14.596 6.19371 14.6116 6.08433C14.6538 5.81089 14.4631 5.55777 14.1897 5.51714Z",
    fill: "#C63031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.31fcc51ed047a87f8a658a786b3d341c.svg";
export { ForwardRef as ReactComponent };